// extracted by mini-css-extract-plugin
export default {"Tag":"Tag-module-cbfaeb8fa6ae9fb381fb","text":"Tag-module-f18782bca6ad5c7a5170"};